import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add\"><defs><style type=\"text/css\"></style></defs><path d=\"M514.048 1018.368c-280.064 0-506.88-226.304-506.88-506.88s226.816-506.88 506.88-506.88c279.552 0 506.88 226.816 506.88 506.88s-227.328 506.88-506.88 506.88z m0-950.272c-244.736 0-443.392 198.656-443.392 443.392s198.656 443.392 443.392 443.392S957.44 756.224 957.44 511.488s-198.656-443.392-443.392-443.392z m189.952 475.648h-158.208v158.208c0 17.92-14.336 31.744-31.744 31.744s-31.744-14.336-31.744-31.744v-158.208H324.096c-17.92 0-31.744-14.336-31.744-31.744s14.336-31.744 31.744-31.744h158.208v-158.72c0-17.92 14.336-31.744 31.744-31.744s31.744 14.336 31.744 31.744v158.208h158.208c17.92 0 31.744 14.336 31.744 31.744 0 17.92-14.336 32.256-31.744 32.256z\" p-id=\"2603\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/add.svg
// module id = TuMq
// module chunks = 10